import { DanceStyleDto } from '../../..';

export class DancePartnerDanceStyleDto {
  danceStyle?: DanceStyleDto;
}
